<template>
  <v-container fluid style="width: 80%" class="text-center">
    <template v-if="loading">
      <v-row justify="center" align="center" style="height: 300px">
        <v-col cols="12" class="d-flex flex-column align-center justify-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="80"
            width="8"
          ></v-progress-circular>
          <div class="mt-4" style="font-size: 1.5rem; color: #1976d2">
            Loading, please wait...
          </div>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <!-- Total Files Card -->
      <v-card class="mb-4" color="primary" dark>
        <v-card-title class="text-h5" style="width: 100%">
          <div
            class="d-flex flex-column flex-sm-row align-center justify-center justify-sm-space-between"
            style="width: 100%"
          >
            <span class="mb-2 mb-sm-0">Total Files: {{ totalCount }}</span>
            <div class="d-flex justify-center" style="gap: 22px">
              <v-chip small color="success" class="white--text">
                <v-icon left small>mdi-play-circle-outline</v-icon>
                {{ activeCount }} Active
              </v-chip>
              <v-chip small color="grey darken-1" class="white--text">
                <v-icon left small>mdi-archive-outline</v-icon>
                {{ archivedCount }} Archived
              </v-chip>
            </div>
          </div>
        </v-card-title>
      </v-card>

      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">DESCRIPTION</th>
              <th class="text-center">NUMBER OF FILES</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="stage in stages"
              :key="stage.id"
              :style="{
                cursor:
                  computedCount(stage.stageCode) > 0
                    ? 'pointer'
                    : 'not-allowed',
                opacity: computedCount(stage.stageCode) > 0 ? 1 : 0.5,
              }"
              @click="
                computedCount(stage.stageCode) > 0 &&
                  viewItem(stage.stageCode, $route.params.id)
              "
            >
              <td>
                {{ stage.name }}
              </td>
              <td v-if="computedCount(stage.stageCode)">
                {{ computedCount(stage.stageCode) }}
              </td>
              <td v-else>0</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </v-container>
</template>

<script>
import CasefileDataService from "../../services/CasefileDataService";
import StageDataService from "../../services/StageDataService";
// import DeptDataService from "../../services/DeptDataService";

export default {
  name: "refTabDetail",
  components: {},

  data() {
    return {
      casefiles: [],
      countsByStatus: {},
      stages: [],
      totalCount: 0,
      activeCount: 0,
      archivedCount: 0,
      // departments: [],
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    Promise.all([this.retrieveStages()])
      .then(() => {
        // initial paginated load for refType
        return this.retrieveCasefilesPage(1, 50);
      })
      .finally(() => {
        this.loading = false;
      });
    // this.retrieveDepts(this.$route.params.id);
  },

  computed: {
    filteredCasefiles() {
      const user = this.$store.state.auth.user || {};
      const roles = Array.isArray(user.roles) ? user.roles : [];

      // ADMIN / MANAGER: full access
      if (roles.includes("MANAGER") || roles.includes("ADMIN")) {
        return this.casefiles;
      }

      // BRANCH-level users: restrict by branch only (no department required)
      if (roles.includes("BRANCHCLERK") || roles.includes("BRANCHMANAGER")) {
        const userBranches = Array.isArray(user.branches)
          ? user.branches
          : user.branches
          ? [user.branches]
          : [];
        if (userBranches.length === 0) {
          // If no branches assigned, return empty list (safe fallback)
          return [];
        }
        return this.casefiles.filter((cf) =>
          userBranches.some((b) => b === cf.branch),
        );
      }

      // ADJUSTER: keep existing tighter filter (dept + branch + adjuster)
      if (roles.includes("ADJUSTER")) {
        const userDepts = Array.isArray(user.dept) ? user.dept : [];
        const userBranches = Array.isArray(user.branches) ? user.branches : [];
        return this.casefiles.filter(
          (x) =>
            (userDepts.length === 0 || userDepts.includes(x.refType)) &&
            (userBranches.length === 0 || userBranches.includes(x.branch)) &&
            String(x.adjuster) === String(user.id),
        );
      }

      // EDITOR: keep existing tighter filter (dept + branch + editor)
      if (roles.includes("EDITOR")) {
        const userDepts = Array.isArray(user.dept) ? user.dept : [];
        const userBranches = Array.isArray(user.branches) ? user.branches : [];
        return this.casefiles.filter(
          (x) =>
            (userDepts.length === 0 || userDepts.includes(x.refType)) &&
            (userBranches.length === 0 || userBranches.includes(x.branch)) &&
            String(x.editor) === String(user.id),
        );
      }

      // Fallback: return all casefiles
      return this.casefiles;
    },
  },

  methods: {
    filterCase(item) {
      return this.filteredCasefiles.filter((a) => a.fileStatus === item);
    },

    // Prefer server-provided total for a fileStatus when available
    computedCount(fileStatus) {
      const serverCounts = this.countsByStatus || {};
      if (serverCounts && typeof serverCounts[fileStatus] !== "undefined") {
        return serverCounts[fileStatus];
      }
      return this.filteredCasefiles.filter((a) => a.fileStatus === fileStatus)
        .length;
    },
    // server-paginated retrieval for refType listing
    async retrieveCasefilesPage(page = 1, limit = 50, search = "") {
      this.loading = true;
      try {
        const refType = this.$route.params.id;
        const user = this.$store.state.auth.user || {};
        const params = {
          page,
          limit,
          search,
          needCount: true,
          roles: user.roles,
          dept: user.dept,
          branches: user.branches,
          userId: user.id,
        };
        const resp = await CasefileDataService.getPaginatedByRefType(
          refType,
          params,
        );
        // handle both legacy full-array and new {data,total}
        if (Array.isArray(resp.data)) {
          // legacy: full array returned
          this.casefiles = resp.data;
          this.totalCount = resp.data.length;
        } else if (resp.data && resp.data.data) {
          this.casefiles = resp.data.data;
          this.totalCount = resp.data.total || resp.data.totalCount || 0;
          // persist per-status totals when backend supplied them
          this.countsByStatus = resp.data.countsByStatus || {};
        } else {
          // fallback
          this.casefiles = resp.data || [];
          this.totalCount = Array.isArray(resp.data) ? resp.data.length : 0;
        }

        // Fetch Active/Archived breakdown for this refType
        try {
          const statusResp = await CasefileDataService.getCountsByStatus(
            "refType",
            params,
          );
          if (statusResp.data && statusResp.data.counts) {
            const counts = statusResp.data.counts;
            this.activeCount = counts.active ? counts.active[refType] || 0 : 0;
            this.archivedCount = counts.archived
              ? counts.archived[refType] || 0
              : 0;
          }
        } catch (e) {
          console.error("Failed to fetch active/archived counts:", e);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    retrieveStages() {
      return StageDataService.getAll()
        .then((response) => {
          this.stages = response.data;
        })
        .catch((e) => {
          console.error(e);
        });
    },

    // retrieveDepts(id) {
    //   DeptDataService.get(id)
    //     .then((response) => {
    //       this.departments = response.data;
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    // },

    viewItem(fileStatus, refType) {
      this.$router.push({
        name: "detail-by-ref",
        // params: { fileStatus: fileStatus },
        params: { fileStatus: fileStatus, refType: refType },
      });
    },
  },
};
</script>

<style scoped>
/* ...existing code... */
</style>
